/**
 * Mobile-only header reorganization: the account button is relocated from the top row into
 * the slot at the top of the hamburger drawer, above the nav links, and moved back when the
 * viewport widens past mobile.
 *
 * The mobile search icon position (immediately next to cart) is handled purely in CSS in
 * sections/header.liquid, so it is correct from the first paint without waiting for this
 * script.
 */

const MOBILE_QUERY = window.matchMedia('(max-width: 749px)');

function sync() {
  const slot = document.querySelector('[data-mobile-account-slot]');
  const headerActions = document.querySelector('header-actions');
  const accountButton = document.querySelector('.account-button');

  if (slot && headerActions && accountButton) {
    if (MOBILE_QUERY.matches) {
      if (accountButton.parentElement !== slot) {
        slot.appendChild(accountButton);
      }
    } else if (accountButton.parentElement === slot) {
      headerActions.prepend(accountButton);
    }
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', sync);
} else {
  sync();
}

MOBILE_QUERY.addEventListener('change', sync);
